import type { NavigationProp, ParamListBase, RouteProp } from '@react-navigation/native'

export type CommonScreenProps<ParamList extends ParamListBase, RouteName extends keyof ParamList = keyof ParamList> = {
  navigation: NavigationProp<ParamList, RouteName>
  route: RouteProp<ParamList, RouteName>
}
